import React from "react";
import "./support.css";
import SupportHeader from "./components/SupportHeader";
import SearchBar from "./components/SearchBar";
import ContactChannels from "./components/ContactChannels";
import CommonQueries from "./components/CommonQueries";
import AdditionalResources from "./components/AdditionalResources";
import RecentTickets from "./components/RecentTickets";
import SupportStats from "./components/SupportStats";
import { useOutletContext } from "react-router-dom";



const Support = () => {
  const { openSidebar } = useOutletContext();
  return (
    <div className="rp-support-page">
      <SupportHeader onMenuClick={openSidebar}/>
      <SearchBar /> 
      <div className="rp-support-content">
        <div className="rp-support-left-section">
          <ContactChannels />
          <CommonQueries />
          <AdditionalResources />
        </div>

        <div className="rp-right-section">
          <RecentTickets />
          <SupportStats />
        </div>
      </div>
    </div>
  );
};

export default Support;
